import styled from '@emotion/styled';
import * as vars from '@shared/styles/abstracts/vars.module.scss';
import type { IconCheckboxPT } from '@shared/ui/inputs/iconCheckbox/ui';

export const SCheckBoxWrapper = styled.section<IconCheckboxPT>`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;

  cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.7' : '1')};
  //padding:8px 0;
`;
export const SLabel = styled.span<{ $checked?: boolean }>`
  margin-left: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => (props.$checked ? vars.colorTextPrimary : vars.colorTextSecondary)};
`;
export const SIconWrapper = styled.div`
  svg {
    width: 26px;
    height: 26px;
  }
`;
